import { render } from "./ModePaiementModal.vue?vue&type=template&id=c1370ee6&ts=true"
import script from "./ModePaiementModal.vue?vue&type=script&lang=ts"
export * from "./ModePaiementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__